import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Table, Button, Tag, Popconfirm, Avatar, Space } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { selectAllTiers, selectTiersStatus } from "../store/tierSlice";
import { doGetTiers, doDeleteTier } from "../store/thunks";
import "./TierList.scss";

const TierList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const tiers = useSelector(selectAllTiers);
  const status = useSelector(selectTiersStatus);

  useEffect(() => {
    dispatch(doGetTiers());
  }, [dispatch]);

  const handleCreate = () => {
    history.push("/admin/billing/tiers/create");
  };

  const handleEdit = (id) => {
    history.push(`/admin/billing/tiers/${id}/edit`);
  };

  const handleDelete = async (id) => {
    await dispatch(doDeleteTier(id));
  };

  const columns = [
    {
      title: "Logo",
      dataIndex: "logo",
      key: "logo",
      width: 80,
      render: (logo) => (
        <Avatar
          src={logo?.url}
          size={48}
          shape="square"
          style={{ backgroundColor: "#f0f0f0" }}
        >
          {!logo && "T"}
        </Avatar>
      )
    },
    {
      title: "Tier Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name)
    },
    {
      title: "Entitlements",
      dataIndex: "entitlementCount",
      key: "entitlementCount",
      width: 150,
      render: (count) => `${count || 0} entitlement${count !== 1 ? "s" : ""}`
    },
    {
      title: "Cost",
      key: "cost",
      width: 150,
      render: (_, record) => (
        <span>
          ${Number(record.cost).toFixed(2)}/{record.period}
        </span>
      )
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      width: 100,
      render: (isActive) => (
        <Tag color={isActive ? "green" : "red"}>{isActive ? "Active" : "Inactive"}</Tag>
      )
    },
    {
      title: "Actions",
      key: "actions",
      width: 150,
      render: (_, record) => (
        <Space size="small">
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record.id)}
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this tier?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <div className="tier-list-page">
      <div className="tier-list-header">
        <h1>Tiers</h1>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleCreate}
          size="large"
        >
          Create New Tier
        </Button>
      </div>
      <div className="tier-list-content">
        <Table
          columns={columns}
          dataSource={tiers}
          rowKey="id"
          loading={status === "loading"}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
          }}
        />
      </div>
    </div>
  );
};

export default TierList;
